import { render } from "./CustomerConfigurations.vue?vue&type=template&id=1a9753e2"
import script from "./CustomerConfigurations.vue?vue&type=script&lang=js"
export * from "./CustomerConfigurations.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__